import { useEffect, useState } from 'react'
import {
  Box, Flex, Stack, Text, Grid, GridItem, Image
} from '@chakra-ui/react'
import { ImagesPng } from 'assets/images'

export const ContactList = ({ name, avatarUrl, lastMessage }) => {
  const test = 'yes'

  // when receiving messages, avatar and message border should be green
  const contactItem = (contact) => (
    <Box
      onClick={() => console.log('yeah')}
      maxHeight="80px"
      border={test ? '1px solid gold' : '1px solid #282828'}
    >
      <Flex gap="10px" padding="3px" alignItems="center">
        <Image
          src={avatarUrl || ImagesPng.ProfileImage}
          height="60px"
          width="60px"
          backgroundColor="white"
          border="2px solid #6272a4"
          borderRadius="10%"
        />
        <Grid templateColumns="repeat(4, 1fr)" gap="10px" fontSize="16px" rowGap="0.9rem" width="calc(100% - 70px)" lineHeight="16px">
          <GridItem border="1px solid white" fontWeight="600" whiteSpace="nowrap" height="22px" overflow="hidden" colSpan={3} padding="2px 7.5px">{name}</GridItem>
          <GridItem border="1px solid white" overflow="hidden" textAlign="center" height="22px" colSpan={1} padding="2px 4px">Item2</GridItem>
          <GridItem border="1px solid white" whiteSpace="nowrap" overflow="hidden" height="22px" textOverflow="ellipsis" colSpan={4} padding="2px 7.5px">{lastMessage}</GridItem>
        </Grid>
      </Flex>
    </Box>
  )

  return (
    <Stack color="cyan">
      {contactItem(test)}
    </Stack>
  )
}
